// extracted by mini-css-extract-plugin
module.exports = {"landing":"LandingPage_landing__30zpM","startButton":"LandingPage_startButton__1-h81"};